import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import _ from 'lodash';

import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import DatePicker from '../../_shared/date-picker/DatePicker';
import * as modalActions from '../../_shared/modal/modalActions';
import { close } from '../projectActions';
import { REAL_ADMIN_R, REAL_AU_R } from '../../../roleaccess/adGroups';

const canEnterDeskAuditDate = (userRole = []) => (
  userRole.includes(REAL_AU_R) || userRole.includes(REAL_ADMIN_R)
);

const mapDispatchToProps = (dispatch, ownProps) => ({
  onConfirm: (deskAuditDate) => {
    dispatch(modalActions.closeModal());
    dispatch(close(ownProps.projectID, ownProps.history, ownProps.projectOpen, deskAuditDate));
  },
  onCancel: () => dispatch(modalActions.closeModal()),
});

export const ProjectCloseModalContent = ({
  onCancel,
  onConfirm,
  projectName,
  userRole,
}) => {
  const [deskAuditDate, setDeskAuditDate] = useState('');
  const canEditDeskAuditDate = userRole && userRole.includes && canEnterDeskAuditDate(userRole);

  return (
    <Fragment>
      <DialogTitle id="responsive-dialog-title">
        Close {projectName}?
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          You are about to close project {projectName}. <br />
          Are you sure you want to proceed?
        </DialogContentText>
        {canEditDeskAuditDate && (
          <DatePicker
            inputLabel="Desk Audit Closing Actual Date *"
            value={deskAuditDate || null}
            onChange={(date) => setDeskAuditDate(date ? date.format('YYYY-MM-DD') : '')}
            placeholder="MM/DD/YYYY"
            dateFormat="MM/DD/YYYY"
            invalidDateMessage="Invalid Date Format"
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => onConfirm(deskAuditDate || null)}
          color="primary"
          disabled={canEditDeskAuditDate && !deskAuditDate}
        >
          Close
        </Button>
      </DialogActions>
    </Fragment>
  );
};

ProjectCloseModalContent.defaultProps = {
  onCancel: _.noop,
  onConfirm: _.noop,
  projectName: '',
  userRole: [],
};

ProjectCloseModalContent.propTypes = {
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  projectName: PropTypes.string,
  userRole: PropTypes.array,
};

export default connect(null, mapDispatchToProps)(ProjectCloseModalContent);
